import { Component, effect, ElementRef, input, OnDestroy, OnInit, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { Chart, ChartConfiguration, ChartType } from 'chart.js';
/*
 * L2-R6: moved from `src/app/shared/charts/chart-render/chart-render.component.ts` (2 reports
 * references). It does NOT touch `chart-renderer.service` — that host service builds the
 * ChartConfiguration and stays where it is; this component only owns the canvas + Chart instance,
 * so the only new dependency for this library is `chart.js` itself.
 *
 * An unused `import { ChartJsConfig } from './chart.model'` was dropped in the move.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-chart-render',
  templateUrl: './chart-render.component.html',
  styleUrl: './chart-render.component.scss',
})
export class ChartRenderComponent implements OnInit, OnDestroy {
  public chartData = input<ChartConfiguration<ChartType>>();
  readonly canvas = viewChild<ElementRef>('canvas');
  private chart: any;
  private chartDataInitialized = false;
  constructor() {
    effect(() => {
      this.chartData();
      if (!this.chartDataInitialized) {
        this.chartDataInitialized = true;
        return;
      }
      if (this.chart) {
        this.chart.update();
      }
    });
  }
  ngOnInit() {
    this.chart = new Chart(this.canvas().nativeElement.getContext('2d'), this.chartData());
  }
  ngOnDestroy() {
  }
}
